/*
 * -----------------------------------------------------------------------
 *  <copyright file="item-wrapper/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */
import React from 'react';
import ActionsMenu from 'views/components/core/actions-menu';

import 'views/components/core/item-wrapper/styles.scss';
import cn from 'clsx';
import { textToId } from '@utils/automation-test-helpers';

interface ItemWrapper {
    title: string;
    itemNumber?: number;
    children: React.ReactNode;
    customRef?: any;
    actions?: any;
    hideItemNumber?: boolean;
    removePadding?: boolean;
    customStyle?: any;
    customChildStyle?: any;
    darkTitle?: boolean;
    customActions?: React.ReactNode;
    className?: string;
    singleActionButton?: React.ReactNode;
}

const ItemWrapper = ({
    title,
    itemNumber,
    children,
    customRef,
    actions,
    hideItemNumber,
    removePadding,
    customStyle,
    customChildStyle,
    darkTitle,
    customActions,
    className,
    singleActionButton,
}: ItemWrapper) => (
    <div
        className={`risk-detail-item-wrapper ${className} ${customActions ? 'custom-actions' : ''}`}
        ref={customRef}
        style={customStyle}
        data-testid={`item-wrapper-${textToId(title)}`}
    >
        <div className={cn('header', { 'dark-title': darkTitle })}>
            <div className="title">{title}</div>
            {itemNumber !== undefined && <div className="item-number">{itemNumber}</div>}

            {!customActions && !!actions && (
                <div className="menu-header">
                    <ActionsMenu
                        actions={actions}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    />
                </div>
            )}
            {customActions}
            {singleActionButton}
        </div>
        <div
            className={`main-container ${!itemNumber && !hideItemNumber ? 'no-items' : ''} ${
                removePadding ? 'no-padding' : ''
            }`}
            style={customChildStyle}
        >
            {children}
        </div>
    </div>
);

export default ItemWrapper;
